
// react-bootstrap imports
import { useState } from "react"
import { Button, Form } from "react-bootstrap"

// components imports
import { SenhaInput, TextInput } from "components/Inputs"
import { ErrorChamadaApiMessage, SuccessDataSaved, WarningIncompleteInput, WarningInvalidInput } from "components/AlertMessages"

import { getFormData } from "services/FormFunctions"

import stdStyle from "json/StdStyles.json"
import { CadastrarUsuario } from "services/CallAPIs"

export const CadastrarUsuarioScreen = () =>
{
    const [matriculaWarning, setMatriculaWarning] = useState("")
    const [warning, setWarning] = useState("")
    const [error, setError] = useState("")
    const [showSucesso, setShowSucesso] = useState(false)
    const [showAlertIncompleteInput, setShowAlertIncompleteInput] = useState(false)
    const [showAlertDadosIncorretos, setShowAlertDadosIncorretos] = useState(false)
    const [showErrorChamarApi, setShowErrorChamarApi] = useState(false)

    function validateInputs()
    {
        let inputsValidos = true
        const matriculaInputData = document.getElementsByName("matricula")[0].value
        const senhaInputData = document.getElementsByName("senha")[0].value
        const senhaConfirmarInputData = document.getElementsByName("senhaConfirmar")[0].value
        setMatriculaWarning("")
        setWarning("")
        setError("")
        if (matriculaInputData !== "" && matriculaInputData.length <= 5)
        {
            setMatriculaWarning("Mínimo de 6 caracteres")
            inputsValidos = false
        }
        if (senhaInputData !== "" && senhaInputData.length <= 5)
        {
            setWarning("Mínimo de 6 caracteres")
            inputsValidos = false
        }
        if (senhaInputData !== "" && senhaInputData.length <= 5)
        {
            setWarning("Mínimo de 6 caracteres")
            inputsValidos = false
        }
        if (senhaInputData === "abc123")
        {
            setWarning("Essa senha já está muito manjada! Evite usá-la")
            inputsValidos = false
        }
        if (senhaInputData !== "" && senhaConfirmarInputData !== "" && senhaConfirmarInputData !== senhaInputData)
        {
            setError("Senhas precisam ser iguais")
            inputsValidos = false
        }

        return inputsValidos
    }

    const submitForm = async event =>
    {
        event.preventDefault()
        const form = event.currentTarget
        const formData = getFormData(form)
        const inputsSaoValidos = validateInputs()
        
        if (!form.checkValidity())
        {
            setShowAlertIncompleteInput(true)
            return
        }
        if (!inputsSaoValidos)
        {
            setShowAlertDadosIncorretos(true)
            return
        }
        if (formData.senha !== formData.senhaConfirmar) { return }

        try
        {
            const data = 
            {
                matricula: formData.matricula,
                nome: formData.nome,
                senha: formData.senha,
                cargo: ""
            }
            await CadastrarUsuario(data, setShowErrorChamarApi)
            setShowSucesso(true)
        }
        catch (error)
        {
            setShowAlertDadosIncorretos(true)
        }
    }

    return (

        <>
            <SuccessDataSaved show={showSucesso} setShow={setShowSucesso} />
            <WarningIncompleteInput show={showAlertIncompleteInput} setShow={setShowAlertIncompleteInput} />
            <WarningInvalidInput show={showAlertDadosIncorretos} setShow={setShowAlertDadosIncorretos} messages={["Matrícula já cadastrada ou senhas não conferem"]} />
            <ErrorChamadaApiMessage apiName={"Login"} show={showErrorChamarApi} setShow={setShowErrorChamarApi} />
            
            <Form className={stdStyle.form} noValidate onSubmit={submitForm}>
            
                <TextInput Name={"matricula"} Placeholder={"000000"} Label={"Matrícula"} Warn={matriculaWarning} OnBlur={validateInputs} Req={true} />
                <TextInput Name={"nome"} Placeholder={"Fulano da Silva"} Label={"Nome completo"} OnBlur={validateInputs} Req={true} />
                <SenhaInput Name={"senha"} Placeholder={"******"} Label={"Senha"} Warn={warning} OnBlur={validateInputs} Req={true} />
                <SenhaInput Name={"senhaConfirmar"} Placeholder={"******"} Label={"Confirme a nova senha"} Errors={error} OnBlur={validateInputs} Req={true} /> 
                <Button className="mt-3" type="submit">Cadastrar</Button>
        
            </Form>
            
        </>

    )
}